// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { keyframes } from '@emotion/react';
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from '@emotion/styled';

import { N30A, N40A } from '@atlaskit/theme/colors';
// eslint-disable-next-line @atlaskit/design-system/no-deprecated-imports
import { gridSize } from '@atlaskit/theme/constants';
import { token } from '@atlaskit/tokens';

import { type Dimension, type SkeletonStyledProps } from './types';

/**
 * Colors for skeleton
 * base identifies the main color of the skeleton
 * shimmer identifies the color of loading effect
 */
const colors = {
	base: token('color.background.neutral', N30A),
	shimmer: token('color.background.neutral.hovered', N40A),
};

/**
 * @param val specifies the dimension value before conversion
 * @returns the CSS value for dimension
 */
const getDimensionValue = (val: Dimension): string => {
	return typeof val === 'string' ? val : `${gridSize() * val}px`;
};

const waveKeyframes = keyframes({
	'0%': {
		backgroundPosition: '-400px 0',
	},
	'100%': {
		backgroundPosition: '400px 0',
	},
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const StyledWrapper = styled.div<SkeletonStyledProps>(
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	({ dimensions }) => {
		return {
			display: 'block',
			backgroundColor: colors.base,
			background: `linear-gradient(to right, ${colors.base} 10%, ${colors.shimmer} 25%, ${colors.base} 40%)`,
			backgroundSize: '800px 64px',
			width: getDimensionValue(dimensions.width),
			height: getDimensionValue(dimensions.height),
			animation: `${waveKeyframes} 1.25s linear infinite forwards`,
			borderRadius: '4px',
			flexShrink: 0,
		};
	},
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	({ variant }) => {
		if (variant === 'line') {
			return { flexShrink: 1 };
		}
		if (variant === 'circle') {
			return { borderRadius: '100%' };
		}
	},
);
